import { ProcessingBadge, type ProcessingBadgeProps } from '@saas-pages/shared/public/app-shell'
import { useT } from '@/shared/i18n'

type LocalizedProcessingBadgeProps = Omit<
  ProcessingBadgeProps,
  'variant' | 'label' | 'title'
> & {
  variant: 'local'
}

export function LocalizedProcessingBadge({
  variant,
  ...props
}: LocalizedProcessingBadgeProps) {
  const t = useT()
  const processing = t.common.processing.local

  return (
    <ProcessingBadge
      variant={variant}
      label={processing?.label}
      title={processing?.title}
      {...props}
    />
  )
}
